import React, { ReactElement } from 'react';
import './footer.scss';

import LogoBestCaravan from 'assets/svgs/logos/logo-best-caravan.svg';
import LogoKaravaan from 'assets/svgs/logos/logo-karavaanielamaa.svg';
import LogoSf from 'assets/svgs/logos/logo-sf.svg';
import {
  ADDRESS,
  BUSINESS,
  POSTAL_RAW,
  SUPPORT_EMAIL,
  SUPPORT_NUMBER,
} from 'constants/contact';
import { useTranslate } from 'hooks/translate';

import { TERMS, PRIVACY_POLICY, MEDIA } from 'constants/paths';

export default function Footer(): ReactElement {
  const BESTPARK_WP = process.env.REACT_APP_BESTPARK_WP ?? '';
  const { t, locale } = useTranslate();
  try {
    const s = 'script';
    const w = window as any;
    const o: string = '_giosg';
    const h = 'https://service.giosg.com';
    const e = window.document.createElement(s);
    e.async = true;
    e.src = h + '/live';
    w[o] =
      w[o] ||
      function() {
        (w[o]._e = w[o]._e || []).push(arguments);
      };
    w[o]._c = '5226';
    w[o]._h = h;
    const n = window.document.querySelectorAll(s)[0];
    // @ts-ignore
    if (!document.querySelector(`script[src="${e.src}"]`)) {
      n?.parentNode?.insertBefore(e, n);
    }
  } catch (error) {
    console.log(error);
  }
  const otherLinks = [
    {
      url: 'https://bestcaravan.fi/',
      src: LogoBestCaravan,
    },
    {
      url: 'https://www.karavaanielamaa.fi/',
      src: LogoKaravaan,
    },
    {
      url: 'https://www.karavaanarit.fi/',
      src: LogoSf,
    },
  ];

  return (
    <div className='footer-component'>
      <div className='footer-widget-top'>
        <div className='footer-widget'>
          <p className='main'>{t('landing_page.footer.contact')}</p>
          <p>
            {BUSINESS}
            <br />
            {ADDRESS}
            <br />
            {POSTAL_RAW}
            <br />
            <a
              className='link-only'
              href='https://goo.gl/maps/w3dvFQxpqZafdz1T9'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('landing_page.footer.see_map')}
            </a>
            <br />
            <br />
            <a
              className='min-link'
              href={`mailto:${SUPPORT_EMAIL}`}
              target='_blank'
              rel='noopener noreferrer'
            >
              {SUPPORT_EMAIL}
            </a>
            <br />
            <br />
            <a className='min-link' href={`tel:${SUPPORT_NUMBER}`}>
              {SUPPORT_NUMBER}
            </a>
            <span className='call-cost'>{t('promotions.hotline.footer')}</span>
          </p>
        </div>
        <div className='footer-widget'>
          <p className='main'>{t('landing_page.footer.travel')}</p>
          {otherLinks.map((i, index) => (
            <a
              key={index}
              className='logo'
              href={i.url}
              rel='noopener noreferrer'
              target='_blank'
            >
              <img src={i.src} alt={`external-${index}`} />
            </a>
          ))}
        </div>
      </div>
      <div className='footer-widget-bottom'>
        <div className='footer-widget'>
          <a href={`${BESTPARK_WP}/${locale}${PRIVACY_POLICY}`}>
            {t('landing_page.footer.privacy')}
          </a>
          <br />
          <a href={`${BESTPARK_WP}/${locale}${TERMS}`}>
            {t('landing_page.footer.terms_of_delivery')}
          </a>
          <br />
          <a href={`${BESTPARK_WP}/${locale}${MEDIA}`}>
            {t('landing_page.footer.media')}
          </a>
          <br />
          <br />
          <br />
          <p>© {new Date().getFullYear()} BestPark</p>
        </div>
      </div>
    </div>
  );
}
